import HistoryTicketsGraph from './styles'
export default HistoryTicketsGraph